import { trans } from "@mongez/localization";
import { settingsAtom } from "core/shared";
import { BaseLink } from "~/design-system/components";
import { getLocalizedValue } from "~/shared/urils/getLocalizedValue";

export type FooterLink = {
  label: string;
  value: string;
  type?: "phone" | "email";
};

export type FooterHours = {
  label: string;
  value: string;
};

type FooterSectionContentProps = {
  type: "pages" | "contact" | "openingHours" | "socialMedia";
  items:
    | FooterLink[]
    | FooterHours[]
    | Array<{ label: React.ReactNode; value: string }>;
};

export function FooterSectionContent({
  type,
  items,
}: FooterSectionContentProps) {
  const contact = settingsAtom.useValue()?.contact || null;

  // Contact settings are per locale: the API omits any field that has no
  // translation for the current locale, and may return it as a localized
  // array, so resolve it to a string and drop whatever is missing.
  const toText = (value: any) => String(getLocalizedValue(value) || "").trim();

  const address = toText(contact?.address);
  const email = toText(contact?.email);
  const phoneNumber = toText(contact?.phoneNumber);
  const whatsappNumber = toText(contact?.whatsappNumber);
  const workingDays = toText(contact?.workingDays);

  const contactItems = [
    {
      label: address,
      href: "",
      type: "address",
    },
    {
      label: email,
      href: `mailto:${email}`,
      type: "email",
    },
    {
      label: phoneNumber,
      href: `tel:${phoneNumber}`,
      type: "phone",
    },
    {
      label: whatsappNumber,
      href: `https://wa.me/${whatsappNumber}`,
      type: "whatsapp",
    },
  ].filter((item) => Boolean(item.label));

  return (
    <ul className="flex flex-col gap-2">
      {type === "pages" &&
        items.map((item, index) => {
          return (
            <li key={index}>
              <BaseLink
                to={item.value}
                title={trans(item.label)}
                className="hover:text-primary-dark transition-colors hover:underline"
              >
                {trans(item.label)}
              </BaseLink>
            </li>
          );
        })}
      {type === "contact" &&
        contact &&
        contactItems.map((item, index) => {
          if (item.type === "address") {
            return (
              <li key={index}>
                <p>
                  {item.label}
                </p>
              </li>
            );
          }

          return (
            <li key={index}>
              <a
                href={item.href}
                title={trans(item.label)}
                className="hover:text-primary-dark transition-colors hover:underline"
              >
                {item.label}
              </a>
            </li>
          );
        })}

      {type === "openingHours" && workingDays && (
        <div
          className="font-medium"
          dangerouslySetInnerHTML={{
            __html: workingDays.split("\n").join("<br />"),
          }}
        />
      )}
    </ul>
  );
}
